import { useModelService } from "@shared/services/api/hooks/useModelService";
import {
  LoginResponse,
  MutatePasswordPayload,
  PasswordResetPayload,
  RegistrationPayload,
} from "@shared/modules/auth/serializer-types";
import { AuthRepository } from "../AuthRepository";

const useAuthService = () => {
  const repository = new AuthRepository();
  const {
    useList,
    useCreate,
    useRetrieve,
    useUpdate,
    useGenericMutation,
    invalidateAllRepositoryQueries,
    removeAllRepositoryQueries,
  } = useModelService(repository);

  const usePasswordReset = () => {
    return useGenericMutation<{ detail: string }, PasswordResetPayload>(
      "passwordReset",
      "POST"
    );
  };

  const useRegistration = () => {
    return useGenericMutation<LoginResponse, RegistrationPayload>(
      "registration",
      "POST"
    );
  };

  const useMutatePassword = () => {
    return useGenericMutation<
      Promise<{ detail: string }>,
      MutatePasswordPayload
    >("mutatePassword", "POST");
  };

  return {
    useList,
    useCreate,
    useRetrieve,
    useUpdate,
    usePasswordReset,
    useRegistration,
    useMutatePassword,
    invalidateAllRepositoryQueries,
    removeAllRepositoryQueries,
  };
};

export default useAuthService;
